// Botón reutilizable "Preguntar a IA" / "Analizar con IA" para cualquier módulo.
import React from 'react';
import { Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useTranslation } from 'react-i18next';
import { openAssistant } from './AssistantLauncher';

export default function AskAIButton({ prompt = '', channelId = null, pageContext = null, label: labelProp,
  variant = 'outlined', size = 'small', ...props }) {
  const { t } = useTranslation();
  const label = labelProp ?? t('hardcoded.components_ai_askaibutton.preguntar_a_ia');
  return (
    <Button
      variant={variant} size={size} color="primary"
      startIcon={<AutoAwesomeIcon />}
      onClick={() => openAssistant(prompt, channelId, pageContext)}
      sx={{ borderColor: 'primary.main', ...(props.sx || {}) }}
      {...props}
    >
      {label}
    </Button>
  );
}
